import { QrCode, CreditCard, Banknote, Link2, Nfc, CalendarClock, CloudSunRain } from "lucide-react";
import Reveal from "./Reveal";

const METHODS = [
  { icon: QrCode, label: "Pix" },
  { icon: CreditCard, label: "Crédito" },
  { icon: Banknote, label: "Débito" },
  { icon: Link2, label: "Link de pagamento" },
  { icon: Nfc, label: "Cartão por aproximação (NFC)" },
];

const NOTES = [
  "Cartão de crédito: possibilidade de parcelamento em até 3x.",
  "Parcelamentos no crédito poderão estar sujeitos a taxas administrativas da operadora, conforme as condições da transação.",
  "A forma de pagamento e as condições do sinal são combinadas no momento da reserva pelo WhatsApp.",
  "O passeio somente será considerado reservado após a confirmação do pagamento do sinal.",
];

const CONDITIONS = [
  {
    icon: CalendarClock,
    title: "Cancelamento e remarcação",
    text: "Cancelamentos e remarcações seguem as condições informadas no momento da reserva. Eventuais valores já destinados à compra de ingressos, reservas ou outros custos poderão estar sujeitos às regras específicas de cada fornecedor.",
  },
  {
    icon: CloudSunRain,
    title: "Clima",
    text: "Em caso de condições climáticas que comprometam a realização ou a segurança da experiência, será avaliada a possibilidade de remarcação. As condições específicas serão informadas no momento da reserva.",
  },
];

export default function PaymentInfo() {
  return (
    <section
      id="pagamento"
      data-testid="payment-info-section"
      className="scroll-mt-24 border-y border-white/10 bg-[#161B22]"
    >
      <div className="mx-auto max-w-7xl px-5 py-24 sm:px-8 sm:py-32">
        <Reveal>
          <p className="font-mono text-xs font-semibold uppercase tracking-[0.25em] text-amber-400">
            Pagamento
          </p>
          <h2 className="mt-4 max-w-3xl font-display text-3xl font-extrabold leading-tight tracking-tight text-stone-50 sm:text-4xl lg:text-5xl">
            Formas de{" "}
            <em className="font-accent font-medium italic text-amber-400">pagamento.</em>
          </h2>
          <p className="mt-5 max-w-2xl text-base leading-relaxed text-stone-300">
            Aceitamos diferentes formas de pagamento para facilitar sua reserva:
          </p>
        </Reveal>

        <div className="mt-10 flex flex-wrap gap-3">
          {METHODS.map((method, i) => (
            <Reveal key={method.label} delay={i * 0.08}>
              <span className="flex items-center gap-2.5 rounded-full border border-white/10 bg-[#0D1117] px-5 py-3 text-sm font-semibold text-stone-200 transition-colors duration-300 hover:border-amber-400/40">
                <method.icon className="h-4 w-4 text-amber-400" />
                {method.label}
              </span>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15}>
          <ul className="mt-10 max-w-3xl space-y-3">
            {NOTES.map((note) => (
              <li key={note} className="flex items-start gap-3 text-sm leading-relaxed text-stone-300 sm:text-base">
                <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-amber-400" />
                {note}
              </li>
            ))}
          </ul>
          <p className="mt-6 font-mono text-[11px] uppercase tracking-[0.2em] text-stone-500">
            Reserva mediante sinal de confirmação · Pix por chave Pix ou QR Code
          </p>
        </Reveal>

        <div className="mt-12 grid gap-6 md:grid-cols-2">
          {CONDITIONS.map((condition, i) => (
            <Reveal key={condition.title} delay={i * 0.12}>
              <article className="h-full rounded-2xl border border-white/10 bg-[#0D1117] p-7">
                <condition.icon className="h-5 w-5 text-amber-400" />
                <h3 className="mt-4 font-display text-lg font-bold text-stone-50">
                  {condition.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-stone-400">{condition.text}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
